import { Select, Space, Typography } from "antd"

const STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: "PROCESSING", label: "PROCESSING" },
  { value: "UPDATED", label: "UPDATED" },
  { value: "PENDING", label: "PENDING" },
  { value: "FAILED", label: "FAILED" },
  { value: "SKIPPED", label: "SKIPPED" },
]

interface HistoryStatusSelectProps {
  value: string
  onChange: (value: string) => void
}

const HistoryStatusSelect: React.FC<HistoryStatusSelectProps> = ({ value, onChange }) => {
  return (
    <Space size={4}>
      <Typography.Text type="secondary">Status</Typography.Text>
      <Select value={value} onChange={onChange} options={STATUS_OPTIONS} />
    </Space>
  )
}

export default HistoryStatusSelect
